<div class="wrapper">
  <div
    id="cf-turnstile"
    class="cf-turnstile"
    data-sitekey="0x4AAAAAABmUALOGbOjJ3EQz"
  ></div>
</div>

@if(this.errorMessage){
<p class="error-message">{{ this.errorMessage }}</p>
}
